<template>
  <div class="usercenter">
    <div class="usercenter__header">
      <el-menu
        :default-active="this.index.toString()"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#051922"
        text-color="#fff"
        active-text-color="#ffd04b">
        <el-menu-item index="0">个人中心</el-menu-item>
        <el-menu-item index="1">我的授权</el-menu-item>
        <el-menu-item v-if="!this.validateUserNull()" index="2">我的产品</el-menu-item>
        <el-menu-item index="3">授权说明</el-menu-item>
        <el-menu-item index="4">答疑说明</el-menu-item>
        <el-menu-item index="99">联系我们</el-menu-item>
      </el-menu>
    </div>
    <div class="productcontent">
      <avue-crud :option="option"
                 :data="list"
                 :page="page"
                 ref="crud"
                 :row-style="rowStyle"
                 :cell-style="cellStyle"
                 @current-change="currentChange"
                 @search-change="searchChange"
                 @search-reset="refreshChange"
                 @size-change="sizeChange"
                 @refresh-change="refreshChange">
        <template slot="header">
          <avue-data-box :option="dataOption"/>
        </template>
        <template v-if="this.user === 'bladex'" slot="menuLeft">
<!--          <el-button type="info"
                     icon="el-icon-circle-plus-outline"
                     @click="handleCreate"
                     size="mini">创建订单
          </el-button>
          <el-button type="warning"
                     icon="el-icon-edit"
                     @click="handleEdit"
                     size="mini">修改订单
          </el-button>-->
<!--          <el-button type="primary"
                     icon="el-icon-edit"
                     @click="handleFp"
                     size="mini">发票开具
          </el-button>
          <el-button type="danger"
                     icon="el-icon-document"
                     @click="$router.push({path:'/pfp'})"
                     size="mini">发票管理
          </el-button>-->
          <el-button type="success"
                     icon="el-icon-data-line"
                     @click="$router.push({path:'/pay-list'})"
                     size="mini">订单管理
          </el-button>
        </template>
        <template slot-scope="scope" slot="type">
          <img width="30"
               :src="scope.row.type === 0 ? '/images/zfbicon.png' : (scope.row.type === 1 ? '/images/wxicon.png' : '/images/zgyhicon.png')">
        </template>
        <template slot="menu" slot-scope="scope">
          <template v-if="!scope.row.flag">
            <el-button type="text"
                       @click="handleOk(scope.row)"
                       size="small">开通
            </el-button>
            <el-button type="text"
                       @click="handleEditPrice(scope.row)"
                       size="small">改价
            </el-button>
            <el-button type="text"
                       @click="handleEditName(scope.row)"
                       size="small">改名
            </el-button>
            <el-button type="text"
                       @click="handleDel(scope.row)"
                       size="small">删除
            </el-button>
            <el-button type="text" v-if="scope.row.version===1"
                       @click="handlePushFlow(scope.row)"
                       size="small">开通
            </el-button>
            <el-button type="text" v-if="scope.row.version===2 || scope.row.version===13"
                       @click="handlePushEmailDags(scope.row)"
                       size="small">开通
            </el-button>
            <el-button type="text" v-if="scope.row.version===16"
                       @click="handlePushScada(scope.row)"
                       size="small">开通
            </el-button>
          </template>
          <template v-if="scope.row.flag">
            <el-button type="text"
                       @click="handleStatus(scope.row)"
                       size="small">修改状态
            </el-button>
          </template>
          <el-button type="text" v-if="scope.row.version===16"
                     @click="handlePushScadaOrder(scope.row)"
                     size="small">订单
          </el-button>
        </template>
      </avue-crud>
    </div>
    <login ref="login" @submit="init"></login>
    <auth v-if="this.user === 'bladex'" ref="auth" @submit="initTable">
    </auth>
  </div>
</template>

<script>
import nav from '@/const/userlist'
import marketlist from "@/const/marketlist";
import {mapState} from "vuex";
import {plugin, payList} from "@/const/config";
import Record from '@/util/record';
import md5 from 'js-md5';

export default {
  name: "temp",
  data() {
    return {
      name: "",
      index: 0,
      nav: nav,
      navObj: {},
      box: false,
      pluginVersion: 0,
      moneyData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSizes: [10, 30, 50, 100, 200, 1000],
        pageSize: 10
      },
      option: {
        size: 'mini',
        excelBtn: true,
        selection: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: true,
        index: true,
        tip: false,
        dialogWidth: 650,
        dialogHeight: 250,
        headerAlign: 'center',
        menuAlign: 'left',
        align: 'center',
        sumColumnList: [
          {
            name: 'money',
            type: 'sum'
          },
          {
            name: 'version',
            type: 'count'
          }
        ],
        defaultSort: {
          prop: 'datetime',
          order: 'descending'
        },
        column: [
          {
            width: 200,
            label: '订单号',
            prop: 'orderid',
            span: 24,
            search: true
          }, {
            label: '授权名',
            prop: 'version',
            type: 'select',
            dicData: plugin,
            filter: true,
            search: false
          }, {
            label: '金额',
            prop: 'money'
          }, {
            label: '授权QQ',
            prop: 'qq',
            search: true
          }, {
            width: 300,
            label: '授权单位',
            prop: 'company',
            search: true,
            hide: true,
          }, {
            label: '支付类型',
            prop: 'type',
            type: 'select',
            dicData: payList,
            filter: true,
            slot: true,
          }, {
            label: '状态',
            prop: 'flag',
            type: 'select',
            filter: true,
            dicData: [{
              label: '已付款',
              value: true
            }, {
              label: '未确认',
              value: false
            }]
          }, {
            label: '下单日期',
            sortable: true,
            prop: 'datetime',
          }
        ]
      },
      list: []
    };
  },
  computed: {
    activeNav() {
      return this.$route.path.replace("/user", "");
    },
    dataOption() {
      return {
        span: 4,
        data: [
          {
            title: '信息',
            count: this.moneyData[0] || "插件订单",
            icon: 'el-icon-s-check',
            color: '#00a680',
            target: '_blank'
          },
          {
            title: '总金额',
            count: this.moneyData[1] || 0,
            icon: 'el-icon-s-order',
            color: '#E6A23C',
            target: '_blank'
          }, {
            title: '上月金额',
            count: this.moneyData[2] || 0,
            icon: 'el-icon-view',
            color: 'rgb(56, 161, 242)',
            target: '_blank'
          },
          {
            title: '本月金额',
            count: this.moneyData[3] || 0,
            icon: 'el-icon-setting',
            color: 'rgb(117, 56, 199)',
            target: '_blank'
          },
          {
            title: '今日金额',
            count: this.moneyData[4] || 0,
            icon: 'el-icon-tickets',
            color: '#F56C6C',
            target: '_blank'
          },
          {
            title: '今日单数',
            count: this.moneyData[5] || 0,
            icon: 'el-icon-user',
            color: 'rgb(97, 60, 189)',
            target: '_blank'
          },
        ]
      }
    },
    ...mapState(['user']),
  },
  watch: {
    $route(n, o) {
      if (this.validatenull(this.user)) {
        return false;
      }
      if (n === o) return;
      this.findItem(this.nav, this.$route.path.replace("/user", ""));
    }
  },
  created() {
    if (this.validateUserNull()) {
      return false;
    }
    this.init();
    if (this.user !== 'bladex') {
      this.initTable();
    }
  },
  mounted() {
    if (this.validatenull(this.user)) {
      this.$message.error({message: '请先购买BladeX授权后登录官网～', offset: 60})
      this.$refs.login.handleOpen()
      return false;
    }
    // 目前超管可看到完整插件资料
    if (this.user === 'bladex') {
      const index1 = this.$refs.crud.findColumnIndex("orderid");
      const index2 = this.$refs.crud.findColumnIndex("version");
      this.option.column[index1].search = false;
      this.option.column[index2].search = true;
    }
    // 目前超管以及工作流插件作者可看到公司信息
    if (this.user === 'bladex' || this.user === '366434565') {
      const index = this.$refs.crud.findColumnIndex("company");
      this.option.column[index].hide = false;
    }
  },
  methods: {
    init() {
      this.findItem(this.nav, this.$route.path.replace("/user", ""));
      const path = this.$route.path.replace("/user/", "");
      if (path === 'center') {
        this.index = 0;
      } else if (path === "auth") {
        this.index = 1;
      } else if (path === "product") {
        this.index = 2;
      } else if (path === "intro") {
        this.index = 3;
      } else if (path === "qa") {
        this.index = 4;
      } else {
        this.index = 99;
      }
    },
    initTable() {
      this.getList();
    },
    handlePushScada(row) {
      this.$confirm(`是否开通<<${row.qq}>>的<<${row.name}>>AvueScada权限`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$httpajax.post(`${this.website.GIT.avueIotUrl}&qq=${row.qq}&key=${this.website.GIT.avueKey}`).then((res) => {
          this.$alert(`${res.data.msg}`, '提示', {
            confirmButtonText: '确定',
          });
        });
      })
    },
    handlePushScadaOrder(row) {
      this.$confirm(`是否推送<<${row.qq}>>的<<${row.name}>>信息至avue系统`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 构建订单信息
        let orderData = {
          qq: row.qq,
          orderid: row.orderid,
          datetime: row.datetime,
          money: row.money,
          version: 9,
          type: 2,
          flag: true
        }
        this.$httpajax.post('https://api.avuejs.com/sysdata?type=0', orderData);
        // 构建发票信息
        let ticketData = {
          qq: row.qq,
          mc: row.company,
          sh: "-",
          orderid: row.orderid,
          datetime: row.datetime,
          flag: true
        }
        this.$httpajax.post('https://api.avuejs.com/sysdata?type=1', ticketData);
        this.dingPush(orderData);
      })
    },
    dingPush(row) {
      this.$httpajax.post('https://payment.javablade.com/api/robot/send', {
        title: "Avue订单推送结果",
        list: [{
          label: "订单号",
          value: row.orderid
        }, {
          label: "用户QQ",
          value: row.qq
        }, {
          label: "套餐类型",
          value: "物联网组态系统",
        }, {
          label: "支付方式",
          value: "对公支付"
        }, {
          label: "授权名称",
          value: row.mc || '暂无'
        }, {
          label: "推送结果",
          value: "成功"
        }]
      })
    },
    handlePushEmailDags(row) {
      this.$confirm(`是否开通<<${row.qq}>>的<<${row.name}>>插件权限`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let version = row.version;
        const sign = md5(row.qq+version+row.money+row.datetime+row.orderid+"blade-email-dags");

        this.$httpajax.post("https://demo.dgsxx.cn/api/blade-order/endpoint/notice", {
          qq: row.qq,
          version: version,
          price: row.money,
          time: row.datetime,
          orderId: row.orderid,
          sign: sign
        }).then((res) => {
          this.$alert(`${res.data.msg}`, '提示', {
            confirmButtonText: '确定',
          });
        });
      })
    },
    handlePushFlow(row) {
      this.$confirm(`是否开通<<${row.qq}>>的<<${row.name}>>工作流插件权限`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let version = 0;
        if (row.money === 899 || row.money === 1899) {
          version = 1;
        } else if (row.money === 2799 || row.money === 3799) {
          version = 2;
        } else if (row.money === 1900 || row.money === 2100 || row.money === 2900 || row.money === 3100) {
          version = 3;
        } else if (row.money === 12999 || row.money === 15999) {
          version = 4;
        } else if (row.money === 9200|| row.money === 11100 || row.money === 12200 || row.money === 14100) {
          version = 5;
        }

        if (version === 0) {
          this.$alert("未知版本，暂停推送", '提示', {
            confirmButtonText: '确定',
          });
          return;
        }

        const sign = md5(row.qq+version+row.money+row.datetime+row.orderid+"blade-workflow");

        this.$httpajax.post("https://notify.nutflow.vip/api/order", {
          qq: row.qq,
          version: version,
          price: row.money,
          time: row.datetime,
          orderid: row.orderid,
          sign: sign
        }).then((res) => {
          this.$alert(`${res.data.msg}`, '提示', {
            confirmButtonText: '确定',
          });
        });
      })
    },
    handleSelect(key) {
      if (this.validatenull(this.user)) {
        return false;
      }
      this.index = Number(key);
      if (this.index === 0) {
        this.$router.push('/user/center');
      } else if (this.index === 1) {
        this.$router.push('/user/auth');
      } else if (this.index === 2) {
        this.$router.push('/user/product');
      } else if (this.index === 3) {
        this.$router.push('/user/intro');
      } else if (this.index === 4) {
        this.$router.push('/user/qa');
      } else if (this.index === 99) {
        this.$router.push('/user/contact');
      }
    },
    findItem(nav, value) {
      nav.forEach(ele => {
        if (ele.groups) {
          this.findItem(ele.groups[0].list, value);
        } else if (ele.path === value) {
          this.navObj = ele;
          this.name = ele.name;
        }
      });
    },
    getMoneyData() {
      let query = new Record("x_market");
      const date = new Date();
      let month = date.getMonth() + 1;
      //month = month < 10 ? '0' + month : month
      let lastmonth = date.getMonth();
      //lastmonth = lastmonth < 10 ? '0' + lastmonth : lastmonth
      let year = date.getFullYear();
      let lastyear = year;
      if (lastmonth === 0) {
        lastyear = year - 1;
        lastmonth = 12;
      }

      const thisDay1 = new Date(year, month - 1, 1).Format('yyyy-MM-dd');
      const thisDay2 = new Date(year, month, 0).Format('yyyy-MM-dd');
      const lastDay1 = new Date(lastyear, lastmonth - 1, 1).Format('yyyy-MM-dd');
      const lastDay2 = new Date(lastyear, lastmonth, 0).Format('yyyy-MM-dd');

      //总订单
      query = new Record("x_market");
      query.equalTo("flag", "=", true);
      // 插件类型查询
      if (this.pluginVersion > 0) {
        query.equalTo("version", "=", `'${this.pluginVersion}'`);
      }
      // 插件作者查询
      if (this.validatePluginUser()) {
        query.equalTo("org", "=", `'${this.user}'`);
      }
      // 设置插件名字
      this.$set(this.moneyData, 0, "插件订单");
      //query.count().then(res => {
      //  this.$set(this.moneyData, 0, res.data)
      //})
      // 总金额
      query.equalTo("flag", "=", true);
      query.sumTo("money");
      // 插件类型查询
      if (this.pluginVersion > 0) {
        query.equalTo("version", "=", `'${this.pluginVersion}'`);
      }
      // 插件作者查询
      if (this.validatePluginUser()) {
        query.equalTo("org", "=", `'${this.user}'`);
      }
      query.find().then(res => {
        const sumMoney = res.data.length > 0 ? res.data[0].total : 0
        this.$set(this.moneyData, 1, sumMoney)
      });
      //上月金额
      query = new Record("x_market");
      query.equalTo("datetime", ">=", `'${lastDay1} 00:00:00'`);
      query.equalTo("datetime", "<=", `'${lastDay2} 23:59:59'`);
      query.equalTo("flag", "=", true);
      query.sumTo("money");
      // 插件类型查询
      if (this.pluginVersion > 0) {
        query.equalTo("version", "=", `'${this.pluginVersion}'`);
      }
      // 插件作者查询
      if (this.validatePluginUser()) {
        query.equalTo("org", "=", `'${this.user}'`);
      }
      query.find().then(res => {
        const sumMoney = res.data.length > 0 ? res.data[0].total : 0
        this.$set(this.moneyData, 2, sumMoney)
      });
      //本月金额
      query = new Record("x_market");
      query.equalTo("datetime", ">=", `'${thisDay1} 00:00:00'`);
      query.equalTo("datetime", "<=", `'${thisDay2} 23:59:59'`);
      query.equalTo("flag", "=", true);
      query.sumTo("money");
      // 插件类型查询
      if (this.pluginVersion > 0) {
        query.equalTo("version", "=", `'${this.pluginVersion}'`);
      }
      // 插件作者查询
      if (this.validatePluginUser()) {
        query.equalTo("org", "=", `'${this.user}'`);
      }
      query.find().then(res => {
        const sumMoney = res.data.length > 0 ? res.data[0].total : 0
        this.$set(this.moneyData, 3, sumMoney)
      });
      //今日金额
      query = new Record("x_market");
      query.equalTo("datetime", ">=", `'${(new Date()).Format('yyyy-MM-dd')}'`);
      query.equalTo("flag", "=", true);
      query.sumTo("money");
      // 插件类型查询
      if (this.pluginVersion > 0) {
        query.equalTo("version", "=", `'${this.pluginVersion}'`);
      }
      // 插件作者查询
      if (this.validatePluginUser()) {
        query.equalTo("org", "=", `'${this.user}'`);
      }
      query.find().then(res => {
        const sumMoney = res.data.length > 0 ? res.data[0].total : 0
        this.$set(this.moneyData, 4, sumMoney)
      });
      //今日订单
      query = new Record("x_market");
      query.equalTo("flag", "=", true);
      query.equalTo("datetime", ">=", `'${(new Date()).Format('yyyy-MM-dd')}'`);
      // 插件类型查询
      if (this.pluginVersion > 0) {
        query.equalTo("version", "=", `'${this.pluginVersion}'`);
      }
      // 插件作者查询
      if (this.validatePluginUser()) {
        query.equalTo("org", "=", `'${this.user}'`);
      }
      query.countTo("money");
      query.find().then(res => {
        this.$set(this.moneyData, 5, res.data[0].total)
      })
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.getList()
    },
    searchChange(params) {
      this.page.currentPage = 1;
      this.pluginVersion = params.version;
      this.getList(params);
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList()
    },
    refreshChange() {
      this.list = [];
      this.pluginVersion = 0;
      this.$message.success('刷新成功')
      this.getList();
    },
    handleOk(row) {
      this.$confirm(`是否更新<<${row.qq}>>的<<${row.name}>>权限`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.flag = true
        return this.update(row.objectId, {
          flag: true
        })
      }).then(() => {
        this.$alert("开通成功", '提示', {
          confirmButtonText: '确定',
        });
      })
    },
    handleStatus(row) {
      this.$confirm(`是否更新<<${row.qq}>>的<<${row.name}>>状态`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.flag = false
        return this.update(row.objectId, {
          flag: false
        })
      }).then(() => {
        this.$alert("修改成功", '提示', {
          confirmButtonText: '确定',
        });
      })
    },
    handleEditPrice(row) {

      const confirmText = ['请修改订单金额'];
      const newDatas = [];
      const h = this.$createElement;
      for (const i in confirmText) {
        newDatas.push(h('p', null, confirmText[i]));
      }
      const that = this;
      this.$prompt('修改确认', '修改确认', {
        message: h('div', null, newDatas),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]+$/,
        inputErrorMessage: '金额格式不正确',
        inputValue: 3799
      }).then(({value}) => {
        row.money = value;
        that.update(row.objectId, {
          money: value
        })
      });

    },
    handleEditName(row) {

      const confirmText = ['请修改授权名称'];
      const newDatas = [];
      const h = this.$createElement;
      for (const i in confirmText) {
        newDatas.push(h('p', null, confirmText[i]));
      }
      const that = this;
      this.$prompt('修改确认', '修改确认', {
        message: h('div', null, newDatas),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        row.company = value;
        that.update(row.objectId, {
          company: value
        })
      });

    },
    handleDel(row) {
      this.$confirm(`是否删除<<${row.qq}>>的<<${row.name}>>订单`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.del(row)
      }).then(() => {
        this.list.splice(row.$index, 1);
        this.$message.success('删除成功')
      })
    },
    handleCreate() {
      this.$message.success('创建订单')
    },
    handleFp() {
      this.$message.success('发票开具')
    },
    insert(data, table) {
      const query = new Record(table || 'x_market');
      const entity = {};
      Object.keys(data).forEach(ele => {
        if (ele.includes('$')) {
          entity[ele.replace('$', '') + '_text'] = data[ele];
        } else {
          entity[ele] = data[ele];
        }
      })
      query.entity(entity);
      return query.save()
    },
    update(id, data, table) {
      const form = this.deepClone(data);
      const query = new Record(table || 'x_market');
      const entity = {};
      entity['id'] = id;
      delete form.createdAt;
      delete form.updatedAt;
      delete form.objectId;
      Object.keys(form).forEach(ele => {
        if (form[ele]) {
          entity[ele] = form[ele]
        }
      })
      query.entity(entity);
      return query.update()
    },
    del(row) {
      const query = new Record('x_market');
      query.remove(row.objectId);
    },
    rowStyle({row}) {
      if (!row.flag) {
        return {
          backgroundColor: 'rgba(245,108,108,0.1)'
        }
      }
    },
    cellStyle({row, columnIndex}) {
      if (columnIndex == 7) {
        return Object.assign((() => {
          return {color: row.type === 0 ? '#409EFF' : (row.type === 1 ? 'green' : 'red'),}
        })(), {
          fontWeight: 'bold',
          fontSize: '20'
        })

      } else if (columnIndex == 8) {
        if (!row.flag) {
          return {
            color: 'red',
            fontWeight: 'bold',
            fontSize: '20'
          }
        }
      } else if (columnIndex == 2) {
        return {
          color: '#333',
          fontWeight: 'bold',
          fontSize: '20'
        }
      }
    },
    getList(params) {
      if (this.validateUserNull()) return false;
      const query = new Record("x_market");
      // 插件作者查询
      if (this.validatePluginUser()) {
        query.equalTo("flag", "=", true);
        query.equalTo("org", "=", `'${this.user}'`);
      }
      // 插件类型查询
      if (this.pluginVersion > 0) {
        query.equalTo("version", "=", `'${this.pluginVersion}'`);
      }
      query.count().then(res => {
        this.page.total = res.data;
        const next = (this.page.currentPage - 1) * this.page.pageSize;
        query.limit(this.page.pageSize)
        query.skip(next)
        query.order("-datetime");
        for (let o in params) {
          //query.equalTo(o, "=", `'${params[o]}'`);
          query.equalTo(o, " like ", `'%${params[o]}%'`);
        }
        return query.find()
      }).then(res => {
        const data = res.data;
        data.forEach(d => {
          d.datetime = new Date(d.datetime).Format("yyyy-MM-dd hh:mm:ss");
        })
        this.list = data;
      });
      this.getMoneyData();
    },
    validateUserNull() {
      if (this.validatenull(this.user)) {
        return true;
      }
      if (this.user === 'bladex') {
        return false;
      }
      const org = marketlist.filter(item => item.org === this.user)
      return this.validatenull(org);
    },
    validatePluginUser() {
      if (this.validatenull(this.user)) {
        return false;
      }
      if (this.user === 'bladex') {
        return false;
      }
      const org = marketlist.filter(item => item.org === this.user)
      return !this.validatenull(org);
    }
  }
};
</script>
<style lang="scss">
.silder {
  width: 280px;
  height: calc(100% - 80px);
  position: fixed;
  top: 0;
  bottom: 0;
  margin-top: 100px;
  overflow: auto;
  background-color: #fff;
  border-right: 1px solid #e8e8e8;

  .item {
    transition: all 0.9s cubic-bezier(0.215, 0.61, 0.355, 1);

    &--bold {
      > a {
        font-weight: 700;
      }
    }

    &--active {
      background-color: #f0f5ff;
      border-right: 3px solid #3e63f9;

      a {
        color: #3e63f9;
      }
    }

    a {
      display: block;
      color: #314659;
    }

    .title {
      font-size: 14px;
      line-height: 40px;
      height: 40px;
      list-style-type: disc;
      list-style-position: inside;
      cursor: pointer;
    }
  }
}

.goods {
  padding-top: 100px;
  margin-bottom: 50px;
  box-sizing: border-box;
  display: flex;
}

.productcontent {
  padding: 10px 10px 50px 10px !important;
  color: #314659;
  min-height: 600px;
  font-size: 14px;
  line-height: 2;
  width: 100%;
  box-sizing: border-box;

  input[type=number] {
    width: 35px !important;
  }

  h2 {
    font-size: 24px;
    line-height: 32px;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #0d1a26;
    font-family: Lato, Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif;
    margin: 1.6em 0 .6em;
    font-weight: 500;
    clear: both;
  }
}
</style>


<style lang="scss">
.usercenter {
  padding-top: 60px;
  min-height: 500px;
  height: auto;

  &__header {
    width: 100%;
  }

  &__title {
    width: 100%;
    font-size: 38px;
    text-align: center;
    font-weight: 600;
    padding-top: 20px;
  }

  &__search {
    width: 600px;
    margin: 25px auto 0 auto;
  }

  &__content {
    width: 100%;
    margin: 30px 0;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    justify-content: center;
  }

  &__text {
    box-sizing: border-box;
    margin: 15px 10px 0 10px;
    width: 20%;
    cursor: pointer;

    p {
      margin-top: 1rem;
      margin-bottom: 0;
      line-height: 30px;
    }
  }
}
</style>
